module.exports = __webpack_public_path__ + "img/crop4_active.79d69000.png";